import React, { useEffect, useState } from 'react'
import { useQuizStore } from '@/store/useQuizStore'
import { emailRegex } from '@/lib/regex'
import { Button } from '@/components/Button/Button'
import { trackEmail, trackLead } from '@/helpers/facebookPixelEvents'

export const Email = ({
  data,
  onValid,
  onNextStep,
}: {
  data: any
  onValid: (val: boolean) => void
  onNextStep: () => void
}) => {
  const currentValue = useQuizStore((s) => s.getAnswer(data.name))
  const [isValid, setIsValid] = useState(emailRegex.test(currentValue as string))
  const [email, setEmail] = useState(currentValue ?? '')
  const setSingle = useQuizStore((s) => s.setSingle)

  const handleChange = (e: any) => {
    const valid = emailRegex.test(e.target.value)
    setIsValid(valid)
    if (valid) {
      setEmail(e.target.value as string)
      setSingle(data.name, e.target.value)
      localStorage.setItem('userEmail', e.target.value)
    }
  }

  useEffect(() => {
    onValid(isValid)
  }, [isValid])

  return (
    <div className="mt-12 relative">
      <label
        htmlFor="email"
        className="absolute top-4 left-6 z-10 font-medium opacity-70 text-[12px]"
      >
        Email address
      </label>
      <input
        className="w-full rounded-3xl bg-boxBg pb-[14px] pt-8 px-6 outline-none placeholder:text-[#101A3666] font-medium"
        type="email"
        onChange={handleChange}
        placeholder="example@mail.com"
        defaultValue={currentValue}
        id="email"
      />
      {!isValid && (
        <span className="text-[12px] block mt-3 text-red-500 font-medium">
          Please enter a valid email address.
        </span>
      )}
      {data?.version === 'alternative' && (
        <div className="mt-12 mb-6 text-center [&_a]:text-buttonGradient text-[#101A3699] text-[14px] leading-[1.55]">
          <img
            width={24}
            height={24}
            className="mx-auto max-w-full mb-2"
            src="/quiz/icons/protection.svg"
            alt="vector"
          />
          <p className="max-w-[240px] mx-auto font-medium">
            Please check our <a href="#">Privacy Policy</a> to understand how we use your data
          </p>
        </div>
      )}

      <Button
        className="mt-6 max-w-full w-full"
        onClick={() => {
          trackLead()
          trackEmail('Mail_completed', email as string)
          onNextStep()
        }}
        disabled={!isValid}
        variant="multistep"
      >
        Continue
      </Button>
    </div>
  )
}
